/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Untitled_JobInputs */

const en_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const de_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const fr_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const es_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const it_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const nl_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const pl_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const fi_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const da_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const sv_keyword_optimizer_untitled_job = /** @type {(inputs: Keyword_Optimizer_Untitled_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Keyword_Optimizer_Untitled_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_untitled_job = /** @type {((inputs?: Keyword_Optimizer_Untitled_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Untitled_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_untitled_job(inputs)
	if (locale === "fr") return fr_keyword_optimizer_untitled_job(inputs)
	if (locale === "es") return es_keyword_optimizer_untitled_job(inputs)
	if (locale === "it") return it_keyword_optimizer_untitled_job(inputs)
	if (locale === "nl") return nl_keyword_optimizer_untitled_job(inputs)
	if (locale === "pl") return pl_keyword_optimizer_untitled_job(inputs)
	if (locale === "fi") return fi_keyword_optimizer_untitled_job(inputs)
	if (locale === "da") return da_keyword_optimizer_untitled_job(inputs)
	if (locale === "sv") return sv_keyword_optimizer_untitled_job(inputs)
	return en_keyword_optimizer_untitled_job(inputs)
});